import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import '../i18n';
import { CronoUserProvider } from './CronoUserProvider';
const GET_USER_DATA = gql `
{
  getLoggedUser {
      preferences {
        language
      }
      id
      isLocked
            exploreLicense {
            id
            countries {
              iso2
              iso3
              name
              intermediateRegionName
              languages
              regionName
              subregionName
              region {
                id
                label
              }
              comtradeId
            }
            activationDate
            expirationDate
            regions {
              id
              label
              countries {
                iso2
                iso3
                name
                intermediateRegionName
                languages
                regionName
                subregionName
                comtradeId
                region {
                  id
                  label
                }
              }
            }
            projectsCount
            isExpired
            lastProjectDate
            enrichPeople
            enabled
          }
          enrichPeopleLicense {
            id
            activationDate
            expirationDate
            enabled
          }
      roles
      activities {
        exploreActivity {
          userCanRunPeople
          userCanRunExploreProject
          exploreProjectsInProgress {
            archived
            creationDate
            comment
            companyCategory
            companyStatus
            completionDate
            country {
              name
              }
            endCompanies
            eta
            id
            industries
            keywords
            name
            parentProjectId
            progress
            scannedPages
            startCompanies
            status
            },
            exploreIterationsInProgress {
              archived
              creationDate
              comment
              companyCategory
              companyStatus
              completionDate
              country {
                name
                }
              endCompanies
              eta
              id
              industries
              keywords
              name
              parentProjectId
              progress
              scannedPages
              startCompanies
              status
              },
              explorePeopleInProgress {
                archived
                creationDate
                comment
                companyCategory
                companyStatus
                completionDate
                country {
                  name
                  }
                endCompanies
                eta
                id
                industries
                keywords
                name
                parentProjectId
                progress
                scannedPages
                startCompanies
                status
                },
          }
        }
      email
      phone
      name
      surname
  }
}
`;
const GET_USER_DATA_DEV = gql `
  {
    getLoggedUser {
        preferences {
          language
        }
        id
        isLocked
              exploreLicense {
              id
              countries {
                iso2
                iso3
                name
                intermediateRegionName
                languages
                regionName
                subregionName
                region {
                  id
                  label
                }
                comtradeId
              }
              activationDate
              expirationDate
              regions {
                id
                label
                countries {
                  iso2
                  iso3
                  name
                  intermediateRegionName
                  languages
                  regionName
                  subregionName
                  comtradeId
                  region {
                    id
                    label
                  }
                }
              }
              projectsCount
              isExpired
              lastProjectDate
              enrichPeople
              enabled
            }
            enrichPeopleLicense {
              id
              activationDate
              expirationDate
              enabled
            }
        roles
        activities {
          exploreActivity {
            userCanRunPeople
            userCanRunExploreProject
            exploreProjectsInProgress {
              archived
              creationDate
              comment
              companyCategory
              companyStatus
              completionDate
              country {
                name
                }
              endCompanies
              eta
              id
              industries
              keywords
              name
              parentProjectId
              progress
              scannedPages
              startCompanies
              status
              },
              exploreIterationsInProgress {
                archived
                creationDate
                comment
                companyCategory
                companyStatus
                completionDate
                country {
                  name
                  }
                endCompanies
                eta
                id
                industries
                keywords
                name
                parentProjectId
                progress
                scannedPages
                startCompanies
                status
                },
                explorePeopleInProgress {
                  archived
                  creationDate
                  comment
                  companyCategory
                  companyStatus
                  completionDate
                  country {
                    name
                    }
                  endCompanies
                  eta
                  id
                  industries
                  keywords
                  name
                  parentProjectId
                  progress
                  scannedPages
                  startCompanies
                  status
                  },
            }
          }
        email
        phone
        name
        surname
    }
  }
`;
const CronoUser = ({ notifications = false, customUserQuery, children, userQueryName = 'getLoggedUser' }) => {
    const [userID, setUserID] = useState('');
    const [userLanguage, setUserLanguage] = useState('en-US');
    useEffect(() => {
        if (customUserQuery) {
            if (customUserQuery.definitions[0].selectionSet.selections[0].name.value !== userQueryName) {
                console.error('YOUR QUERY DOES NOT INCLUDE THE RIGHT userQueryName');
            }
        }
    }, [customUserQuery]);
    const userDataProvided = (data) => {
        if (process.env.REACT_APP_URI_ENV !== 'prod') {
            console.log('language settings data:', data);
        }
        setUserLanguage(data.loggedUser.preferences.language);
        setUserID(data.loggedUser.id);
    };
    const debugError = (e) => {
        console.error(e);
    };
    const { data, loading: loadingUserData, refetch: refetchUserData } = useQuery(customUserQuery || (process.env.REACT_APP_URI_ENV !== 'prod' ? GET_USER_DATA_DEV : GET_USER_DATA), {
        fetchPolicy: 'cache-and-network',
        onCompleted: userDataProvided,
        onError: debugError
    });
    return (!loadingUserData
        ? _jsx(CronoUserProvider, Object.assign({ setUserLanguage: setUserLanguage, userLanguage: userLanguage, userID: userID, userData: data, refetchLoggedUser: refetchUserData, loadingLoggedUser: loadingUserData, userQueryName: userQueryName }, { children: children }))
        : _jsx(_Fragment, {}));
};
export default CronoUser;
